import { minutesToTaskDuration } from 'aos-helpers/src/helpers/Time'
import { AosSeverity } from 'aos-services/src/services/common/types/AosSeverity'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import { TaskStatus } from 'aos-services/src/services/tasks/types/TaskStatus'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskDurationField } from '../TaskDurationField'
import { TaskFormField } from '../TaskFormField'

export const TaskSpendTimeField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload

    if (task.status !== TaskStatus.Done || task.severity === AosSeverity.Maintenance) {
        return null
    }

    return (
        <Controller
            control={control}
            name='spendTimeInMinutes'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.spend-time.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('form.spend-time.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <TaskDurationField
                        value={field.value ? minutesToTaskDuration(field.value) : undefined}
                        onChange={taskDuration =>
                            field.onChange(
                                (taskDuration?.hour || 0) * 60 + (taskDuration?.minute || 0),
                            )
                        }
                    />
                </TaskFormField>
            )}
        />
    )
}
